import React from "react";

import Link from "gatsby-link";
import GalleryLink from "../components/gallerylink";

export default class Nav extends React.Component {
  handleClick(event) {
    if (event.target.tagName.toLowerCase() === "a") event.target.blur();
  }

  render() {
    return (
      <nav id="page_nav">
        <ul onClick={this.handleClick}>
          <li>
            <Link to="/" exact activeClassName="current">
              Home
            </Link>
          </li>
          <li>
            <Link to="/about-us/" activeClassName="current">
              About Us
            </Link>
          </li>
          <li>
            <GalleryLink>Projects</GalleryLink>
          </li>
          <li>
            <Link to="/contact/" activeClassName="current">
              Contact
            </Link>
          </li>
        </ul>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/nav.js